/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./roomBuy.vue?vue&type=template&id=7fbd2ee2&scoped=true&"
import script from "./roomBuy.vue?vue&type=script&lang=js&"
export * from "./roomBuy.vue?vue&type=script&lang=js&"
import style0 from "./roomBuy.vue?vue&type=style&index=0&id=7fbd2ee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbd2ee2",
  null
  
)

export default component.exports